import React, { useEffect, useState } from "react";
import { EditProps } from "../types";
import FormTextField from "src/shared/components/FormTextField";
import ConfigModalLayout from "./ConfigModalLayout";

const EditConfigModal: React.FC<EditProps> = ({ open, onClose, onSave, config }) => {
  const [conname, setConname] = useState("");
  const [convalue, setConvalue] = useState<number | "">("");

  useEffect(() => {
    if (config) {
      setConname(config.conname);
      setConvalue(config.convalue ?? "");
    }
  }, [config]);

  const handleSave = () => {
    if (config && conname && convalue !== "") {
      onSave(config._id.$oid, conname, Number(convalue));
      onClose();
    }
  };

  return (
    <ConfigModalLayout
      open={open}
      onClose={onClose}
      title="Edit Configuration"
      confirmLabel="Update"
      confirmVariant="primary"
      onConfirm={handleSave}
    >
      <FormTextField
        id="config-name"
        label="Configuration Name"
        value={conname}
        onChange={(e) => setConname(e.target.value)}
      />
      <FormTextField
        id="config-value"
        label="Configuration Value"
        type="number"
        value={convalue === "" ? "" : String(convalue)}
        onChange={(e) =>
          setConvalue(e.target.value === "" ? "" : Number(e.target.value))
        }
      />
    </ConfigModalLayout>
  );
};

export default EditConfigModal;
